import styles from "./Loader.module.css";

function Loader() {
  return (
    <div className="page-load-status my-auto">
      <p className={styles.container}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </p>
    </div>
  );
}

export default Loader;
